<template>
<div class="blog-card-description">
  <h2>
    <div v-if="showContentType" class="ml1 mr1 right ti-color">REPORT</div>
    <span class="report-card-title">
      {{report.title}}
    </span>
    <span v-if="report.status=='DRAFT'" style="color:red">(DRAFT)</span>
  </h2>
  <div class="blog-card-date">
    <span v-if="report.report_type">{{report.report_type_label}} |</span>
    <span v-if="report.white_paper">WHITE PAPER |</span>
    <span v-else-if="report.essential_read">ESSENTIAL READING |</span>
    <!-- <span v-else-if="report.ti_group">USER GROUP |</span> -->
    {{ report.date_us_str }}
    <template v-if="report.authors"> |
      <span v-for="(author, index) in report.authors" :key="author.name">
        <span class="report-card-author">
          {{ author.name }}
        </span>
        <span v-if="index+1 < report.authors.length"> ; </span>
      </span>
    </template>
  </div>

  <div class="blog-card-intro" style="min-height:40px; margin-top:4px;">
    <div v-if="report.intro" :class="[introLong ? 'ti-line5' : 'ti-line3']"
         style="max-width:640px;">
      {{report.intro}}
    </div>
  </div>

  <!-- report_props -->
  <div v-if="report.num_pages" class="ti-card-prop-label mt1">
    Number of Pages:
    <span class="ti-card-prop-value">
      {{ report.num_pages }}
    </span>
  </div>

  <div v-if="showOrgs && report.organizations.length" class="ti-card-prop-label">
    <span style="margin-right:6px;">Organisations covered:</span>
    <span v-for="(org, index) in report.organizations" :key="org.name" >
      <span class="ti-card-prop-value-list">
        {{org.name}}
      </span>
      <span v-if="index+1 < report.organizations.length"> | </span>
    </span>
  </div>

  <div v-if="report.keywords.length" class="ti-card-prop-label ti-line3">
    <span style="margin-right:6px;">Keywords:</span>
    <span v-for="(word, index) in report.keywords" :key="index" >
      <span class="ti-card-prop-value-list">
        {{word.name}}
      </span>
      <span v-if="index+1 < report.keywords.length"> | </span>
    </span>
  </div>

  <!-- transforma_tags -->
  <div v-if="showTags" style="line-height:24px; padding: 4px 0;">
    <TransformaTags label="region" :low="true" :small="true"
                    :all="report.region_all" :items="report.regions"/>
    <TransformaTags label="vertical" :low="true" :small="true"
                    :all="report.sector_all" :items="report.sectors"/>
    <TransformaTags label="technology" :low="true" :small="true"
                    :all="report.technology_all" :items="report.technologies"/>
  </div>
</div>
</template>


<script>
import TransformaTags from '@/components/TransformaTags.vue';

export default {
  name: 'ReportCard',
  components: {
    TransformaTags,
  },
  props: {
    report: { type: Object, required: true },
    showTags: { type: Boolean, default: true },
    showOrgs: { type: Boolean, default: true },
    introLong: { type: Boolean, default: false }, // default clamp 3 lines. long: 5 lines.
    showContentType: { type: Boolean, default: false },
  },
  data() {
    return {
    };
  },

  computed: {
  },
};
</script>
